import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectBehaviourDesc, selectShowInvalids } from '@store/order/selectors';
import { setBehaviourDesc } from '@store/order/slice';
import calmDog from '@assets/images/order-calm-dog.svg';
import wildDog from '@assets/images/order-wild-dog.svg';
import { invalidFormValue } from '@components/utils';
import { CharacterTypeEnum } from '@pages/order/animal-info/CharacterTypeEnum';



const CharacterSection = () => {
	const { t } = useTranslation('forms');

	const behaviourDesc = useSelector(selectBehaviourDesc);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateBehaviourDesc = (value: string | null) => dispatch(setBehaviourDesc(value));

	return (
		<div className='character-section'>

			<label className='character-label'>
				{t('animalInfo.character.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(behaviourDesc) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<div className='character-elements'>

				<div className='character-element'>
					<div
						className={`character-icon disable-selection${behaviourDesc === CharacterTypeEnum.calm ? ' active-character' : ''}`}
						onClick={() => updateBehaviourDesc(CharacterTypeEnum.calm)}>
						<img src={calmDog} alt='calm-character-icon' draggable={false} />
					</div>
					
					<div className='character-icon-label'>
						<p>{t('animalInfo.character.characterTypeEnum.calm')}</p>
					</div>
				</div>


				<div className='character-element'>
					<div
						className={`character-icon disable-selection${behaviourDesc === CharacterTypeEnum.wild ? ' active-character' : ''}`}
						onClick={() => updateBehaviourDesc(CharacterTypeEnum.wild)}>
						<img src={wildDog} alt='wild-character-icon' draggable={false} />
					</div>
					
					<div className='character-icon-label'>
						<p>{t('animalInfo.character.characterTypeEnum.wild')}</p>
					</div>
				</div>
			
			</div>
		</div>
	);
};

export default memo(CharacterSection);